import React, { useCallback, useEffect, useState } from "react";

import { getUserFarms } from "services";

import { AdminTable, Col, Row } from "components";

export const UserFarmsTab = ({ user }) => {
  const [farms, setFarms] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadUserFarms = useCallback(() => {
    setLoading(true);
    getUserFarms({
      userId: user.id,
    })
      .then((res) => {
        const farmsDetails = [];
        res.map((farm) => {
          const farmDetails = farm.farm;
          return farmsDetails.push({
            id: farmDetails.id,
            name: farmDetails.name,
            IdDeal: farmDetails.dealId,
            region: farmDetails.region,
            verified: farmDetails.verified,
            disabled: farmDetails.disabled,
            referralToken: farmDetails.referralToken,
          });
        });
        setFarms(farmsDetails);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [user.id]);

  useEffect(() => {
    loadUserFarms();
  }, [loadUserFarms]);

  return !loading ? (
    <>
      <Row>
        <Col>
          <AdminTable
            dataSource={farms}
            config={{
              exclude: ["id"],
              actions: [
                {
                  icon: "klim/farm",
                  route: "/farm/",
                  record: "id",
                  tooltip: "View this farm",
                },
              ],
            }}
          />
        </Col>
      </Row>
    </>
  ) : null;
};
